import { G } from "../../constants/theme";

export default function SI({ k, v }) {
  return (
    <div
      style={{
        background: G.card,
        padding: "26px 28px",
        borderBottom: `1px solid ${G.border}`,
      }}
    >
      <div
        style={{
          fontFamily: "monospace",
          fontSize: 9,
          letterSpacing: 2,
          color: G.muted,
          textTransform: "uppercase",
          marginBottom: 7,
        }}
      >
        {k}
      </div>
      <div style={{ fontSize: 14, color: G.white, fontWeight: 500 }}>{v}</div>
    </div>
  );
}
